import { Accordion, AccordionTab } from "primereact/accordion";
import { Dialog } from "primereact/dialog";
import React from "react";
import MonsterCompanySettingForm from "./monsterCompanySetting/MonsterCompanySettingForm";
import MonsterBranchSettingForm from "./monsterBranchSetting/MonsterBranchSettingForm";
import MonsterTeamSettingForm from "./monsterTeamSetting/MonsterTeamSettingForm";
import MonsterUserSettingForm from "./monsterUserSetting/MonsterUserSettingForm";
import { ILogin } from "../../../models/Login";
interface IProps {
  open: boolean;
  hideDialog: () => void;
  toast: any;
  reload: boolean;
  setReload: (is: boolean) => void;
}
const Form = (props: IProps) => {
  const onHide = () => {
    props.hideDialog();
  };

  let _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  return (
    <>
      <Dialog style={{ width: "80vw" }} header="Monster Setting" className="p-fluid" modal visible={props.open} onHide={onHide} maximizable>
        <Accordion multiple activeIndex={[0]}>
          {_roles.includes(1) && (
            <AccordionTab header="Monster Company Wise Setting">
              <MonsterCompanySettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
            </AccordionTab>
          )}
          {_roles.includes(1) && (
            <AccordionTab header="Monster Branch Wise Setting">
              <MonsterBranchSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
            </AccordionTab>
          )}
          {(_roles.includes(1) || _roles.includes(4)) && (
            <AccordionTab header="Monster Team Wise Setting">
              <MonsterTeamSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
            </AccordionTab>
          )}
          {(_roles.includes(1) || _roles.includes(4) || _roles.includes(6)) && (
            <AccordionTab header="Monster User Wise Setting">
              <MonsterUserSettingForm reload={props.reload} setReload={props.setReload} toast={props.toast} />
            </AccordionTab>
          )}
        </Accordion>
      </Dialog>
    </>
  );
};

export default Form;
